import React from 'react';
import { DataGridButton, IColumnType, IDataType, SisDataGridColumns } from '../../components/table';

export const Columns = (handleEdit, handleRemove, translate): SisDataGridColumns => [
  {
    dataType: IDataType.number,
    dataField: 'id',
    width: '5%',
    caption: 'Maintenance cost type id',
  },
  {
    dataType: IDataType.string,
    dataField: 'name',
    width: '25%',
    caption: 'Name',
  },
  {
    dataType: IDataType.number,
    dataField: 'sortOrder',
    width: '10%',
    caption: 'Sort order',
  },
  {
    dataField: 'visible',
    dataType: IDataType.boolean,
    caption: 'Visible',
    width: '7%',
  },
  {
    type: IColumnType.buttons,
    cellRender: (data) => ButtonCell(data, handleEdit, handleRemove, translate),
    width: '10%',
  },
];

const ButtonCell = (cellData, handleEdit, handleRemove, translate) => {
  return (
    <>
      <DataGridButton
        hint={translate!('Edit', '')}
        icon="edit"
        cellData={cellData}
        onClick={() => handleEdit(cellData)}
      />
      <DataGridButton
        hint={translate!('Delete', '')}
        icon="trash"
        cellData={cellData}
        onClick={() => handleRemove(cellData)}
      />
    </>
  );
};
